import { HomeHero } from "../components/organisms/HomeHero.tsx";
import { InteractiveDesk } from "../components/organisms/InteractiveDesk.tsx";
import { LabdSection } from "../components/organisms/LabdSection.tsx";
import { WhatsNewStrip } from "../components/organisms/WhatsNewStrip.tsx";
import { useSettings } from "../lib/data.tsx";

export function HomePage() {
  const settings = useSettings();
  return (
    <main className="view active" aria-label="The desk">
      <HomeHero settings={settings.value} />
      <InteractiveDesk settings={settings.value} />
      <LabdSection />
      <WhatsNewStrip />
    </main>
  );
}
